var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.$style.kioskTryBlock, style: _vm.backgroundStyle },
    [
      _c("div", { class: _vm.$style.overlay }),
      _vm._v(" "),
      _c("div", { class: _vm.$style.kioskTryContent }, [
        _c("h2", { class: _vm.$style.kioskTryTitle }, [
          _vm._v("\n      Try Our "),
          _c("span", [_vm._v(" Vegan Black Bean Patty ")])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/KioskTryBlock.vue?vue&type=template&id=201d53ca&
// module id = null
// module chunks = 